import { ArrowUpRight } from "lucide-react";
import { useEffect, useRef } from "react";

const SCRIPT_ID = "tidycal-embed-script";
const SCRIPT_SRC = "https://asset-tidycal.b-cdn.net/js/embed.js";

const TidyCalEmbed = ({ path, title, fallbackHref, testId }) => {
  const embedRef = useRef(null);

  useEffect(() => {
    const embed = embedRef.current;
    if (!embed) return undefined;

    embed.replaceChildren();
    embed.classList.add("tidycal-embed");
    embed.dataset.path = path;
    embed.setAttribute("aria-label", `${title} live booking calendar`);

    const loading = document.createElement("p");
    loading.className = "tidycal-loading";
    loading.textContent = "Loading live booking calendar…";
    embed.appendChild(loading);

    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      embed.replaceChildren();
      embed.classList.remove("tidycal-embed");
      delete embed.dataset.path;
      embed.removeAttribute("aria-label");
    };
  }, [path, title]);

  return (
    <div className="tidycal-embed-stack">
      <div className="tidycal-widget-host" data-testid={testId}>
        <p className="tidycal-status" aria-hidden="true">Live TidyCal calendar area</p>
        <div ref={embedRef} className="tidycal-embed" />
      </div>
      <a className="button button-outline tidycal-direct-link" href={fallbackHref} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-fallback`}>
        Book Direct on TidyCal <ArrowUpRight size={15} />
      </a>
    </div>
  );
};

export default TidyCalEmbed;
